// Lista de módulos/assuntos disponíveis no site.
// Cada módulo aponta para um arquivo Markdown em public/resumos/<id>.md
// e para um quiz opcional em public/quizzes/<id>.json.

export const modulesList = [
  {
    id: 'direito-constitucional',
    title: 'Direito Constitucional',
    color: '#3f51b5',
  },
  {
    id: 'direito-processual-civil',
    title: 'Direito Processual Civil',
    color: '#00bfa5',
  },
  {
    id: 'raciocinio-logico-e-matematica',
    title: 'Raciocínio Lógico e Matemática',
    color: '#ff5722',
  },
];
